import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Analytics.css'
import analyticsHero from "../../../assets/images/Business Analytics.png";
import analyticsGraph from "../../../assets/images/Business Analytics.png";

const AnalyticsPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> MIS Analytics – BuddyTech Solutions </title>
        <meta name="description" content="Predictive and prescriptive analytics with Python, Power BI, and intelligent dashboards." />
        <meta name="keywords" content="business intelligence, predictive analytics" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="MIS Analytics – BuddyTech Solutions" />
        <meta property="og:description" content="Predictive and prescriptive analytics with Python, Power BI, and intelligent dashboards." />
        <meta property="og:keywords" content="business intelligence, predictive analytics" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/mis/analytics" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="MIS Analytics – BuddyTech Solutions" />
        <meta name="twitter:description" content="Predictive and prescriptive analytics with Python, Power BI, and intelligent dashboards." />
        <meta name="twitter:keywords" content="business intelligence, predictive analytics" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="analytics-container">
        <header className="analytics-hero">
          <div className="analytics-hero-content">
            <h1>Business Intelligence & Analytics</h1>
            <p>
              Empower your decisions with insightful analytics and predictive reporting. We help visualize patterns and uncover hidden opportunities.
            </p>
          </div>
          <img src={analyticsHero} alt="Analytics Hero" className="analytics-hero-img" />
        </header>

        <section className="analytics-section">
          <div className="analytics-text">
            <h2>Our Analytics Capabilities</h2>
            <p>
              We turn complex datasets into clear, meaningful visualizations and models to support strategic planning and operational excellence.
            </p>
            <ul>
              <li>KPI Monitoring & Business Metrics</li>
              <li>Predictive & Prescriptive Analytics</li>
              <li>Custom Data Models & Algorithms</li>
              <li>Interactive Charts & Heatmaps</li>
              <li>Performance Trend Analysis</li>
            </ul>
          </div>
          <img src={analyticsGraph} alt="Analytics Chart" className="analytics-img" />
        </section>

        <section className="analytics-tools">
          <h2>Tools & Technologies</h2>
          <div className="tools-grid">
            <span>Power BI</span>
            <span>Google Looker Studio</span>
            <span>Tableau</span>
            <span>Python (Pandas, Matplotlib)</span>
            <span>Excel Power Query</span>
            <span>Google Sheets</span>
            <span>BigQuery</span>
            <span>SQL & NoSQL Databases</span>
          </div>
        </section>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:Augustine.g.1992@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/917418763500" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+917418763500">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default AnalyticsPage;